import React from 'react';
import Context from '../../assets/js/Context';
import Component from "@reactions/component";
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { SideSheet, Position, Dialog } from 'evergreen-ui';
import qs from 'qs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from '../common/login';
import { Button, Row, Col, Container, Alert, Table, Card } from 'react-bootstrap';
import Key from '@material-ui/icons/LockOpen';
import PersonAdd from '@material-ui/icons/PersonAdd';
import Assessment from '@material-ui/icons/Assessment';
import People from '@material-ui/icons/People';
import Dashboard from '@material-ui/icons/Dashboard';

const cookies = new Cookies();

const styles = `
  .modern-container {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    padding: 20px 0;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }

  .glass-card {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
    padding: 30px;
    margin-bottom: 20px;
    transition: all 0.3s ease;
  }

  .glass-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px 0 rgba(31, 38, 135, 0.5);
  }

  .section-title {
    color: #fff;
    text-align: center;
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 30px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
  }

  .action-card {
    background: linear-gradient(145deg, #ffffff, #f0f0f0);
    border-radius: 15px;
    padding: 25px;
    margin: 15px 0;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    cursor: pointer;
    border: none;
    text-decoration: none;
    color: inherit;
    display: block;
  }

  .action-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0,0,0,0.2);
    color: inherit;
    text-decoration: none;
  }

  .card-icon {
    font-size: 3rem;
    color: #667eea;
    margin-bottom: 15px;
    transition: color 0.3s ease;
  }

  .action-card:hover .card-icon {
    color: #764ba2;
  }

  .card-title {
    font-size: 1.3rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }

  .card-description {
    color: #666;
    font-size: 0.95rem;
    line-height: 1.5;
  }

  .modern-btn {
    background: linear-gradient(45deg, #667eea, #764ba2);
    border: none;
    border-radius: 25px;
    color: white;
    padding: 12px 30px;
    font-weight: bold;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
    margin: 5px;
  }

  .modern-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.6);
    background: linear-gradient(45deg, #764ba2, #667eea);
  }

  .modern-btn-secondary {
    background: linear-gradient(45deg, #ff6b6b, #ffa726);
    border: none;
    border-radius: 25px;
    color: white;
    padding: 12px 30px;
    font-weight: bold;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
    margin: 5px;
  }

  .modern-btn-secondary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(255, 107, 107, 0.6);
    background: linear-gradient(45deg, #ffa726, #ff6b6b);
  }

  .modern-input {
    border: 2px solid #e0e0e0;
    border-radius: 15px;
    padding: 15px 20px;
    font-size: 16px;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.9);
    margin-bottom: 15px;
    width: 100%;
  }

  .modern-input:focus {
    border-color: #667eea;
    box-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
    outline: none;
    background: white;
  }

  .modern-select {
    border: 2px solid #e0e0e0;
    border-radius: 15px;
    padding: 15px 20px;
    font-size: 16px;
    transition: all 0.3s ease;
    background: rgba(255, 255, 255, 0.9);
    margin-bottom: 15px;
    width: 100%;
    cursor: pointer;
  }

  .modern-select:focus {
    border-color: #667eea;
    box-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
    outline: none;
    background: white;
  }

  .modern-table {
    background: white;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
    margin-top: 20px;
  }

  .modern-table th {
    background: linear-gradient(45deg, #667eea, #764ba2);
    color: white;
    border: none;
    padding: 15px;
    font-weight: bold;
  }

  .modern-table td {
    padding: 15px;
    border: none;
    border-bottom: 1px solid #f0f0f0;
    vertical-align: middle;
  }

  .modern-table tr:hover {
    background-color: #f8f9ff;
  }

  .form-label {
    color: #333;
    font-weight: bold;
    margin-bottom: 8px;
    display: block;
  }

  .side-sheet-content {
    padding: 30px;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    min-height: 100vh;
  }

  .side-sheet-title {
    background: linear-gradient(45deg, #667eea, #764ba2);
    color: white;
    padding: 20px;
    border-radius: 15px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 30px;
    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 20px;
    margin-bottom: 30px;
  }

  .management-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 20px;
    margin-top: 30px;
  }

  @media (max-width: 768px) {
    .modern-container {
      padding: 10px;
    }
    
    .glass-card {
      padding: 20px;
      margin: 10px 0;
    }
    
    .section-title {
      font-size: 1.5rem;
    }
    
    .action-card {
      padding: 20px;
      margin: 10px 0;
    }
    
    .card-icon {
      font-size: 2.5rem;
    }
    
    .stats-grid {
      grid-template-columns: 1fr;
    }
    
    .management-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 480px) {
    .modern-btn, .modern-btn-secondary {
      padding: 10px 20px;
      font-size: 14px;
    }
    
    .modern-input, .modern-select {
      padding: 12px 15px;
      font-size: 14px;
    }
  }
`;

class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            nameCate: '',
            Category: [],
            spin: false,
            admins: [],
        }
    }

    componentDidMount() {
        var header = { "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token") };
        axios.get(host + `dashbord/admins/all`, { headers: header })
            .then(res => {
                this.setState({
                    admins: res.data.admins, spin: true
                });
            })
            .catch(error => { console.log(error.response) })
    }

    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        return (
                            <div className="modern-container">
                                <style>{styles}</style>

                                <Container>
                                    {/* Dashboard Header */}
                                    <div className="glass-card">
                                        <h1 className="section-title">
                                            <Dashboard style={{ marginRight: '10px', verticalAlign: 'middle' }} />
                                            لوحة التحكم الإدارية
                                        </h1>
                                    </div>

                                    {/* Reports Section */}
                                    <div className="glass-card">
                                        <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '30px' }}>
                                            <Assessment style={{ marginRight: '10px', verticalAlign: 'middle' }} />
                                            تقارير الطلبات
                                        </h2>
                                        
                                        <div className="stats-grid">
                                            <a href="/wattingselles" className="action-card">
                                                <div style={{ textAlign: 'center' }}>
                                                    <div className="card-icon">⏳</div>
                                                    <div className="card-title">طلبات الانتظار</div>
                                                    <div className="card-description">عرض الطلبات المعلقة في الانتظار</div>
                                                </div>
                                            </a>

                                            <a href="/check" className="action-card">
                                                <div style={{ textAlign: 'center' }}>
                                                    <div className="card-icon">❓</div>
                                                    <div className="card-title">الطلبات غير المؤكدة</div>
                                                    <div className="card-description">الطلبات التي تحتاج تأكيد</div>
                                                </div>
                                            </a>

                                            <a href="/miss" className="action-card">
                                                <div style={{ textAlign: 'center' }}>
                                                    <div className="card-icon">📋</div>
                                                    <div className="card-title">الإيراد</div>
                                                    <div className="card-description">تقارير الإيرادات والأرباح</div>
                                                </div>
                                            </a>

                                            <a href="/selles" className="action-card">
                                                <div style={{ textAlign: 'center' }}>
                                                    <div className="card-icon">💰</div>
                                                    <div className="card-title">المبيعات</div>
                                                    <div className="card-description">تقارير المبيعات المكتملة</div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>

                                    {/* Management Section */}
                                    <div className="glass-card">
                                        <h2 style={{ color: '#fff', textAlign: 'center', marginBottom: '30px' }}>
                                            <People style={{ marginRight: '10px', verticalAlign: 'middle' }} />
                                            إدارة الموظفين والنظام
                                        </h2>
                                        
                                        <div className="management-grid">
                                            {/* Employee Management */}
                                            <Component initialState={{ isShown: false, nameUser: '', phoneUser: '', passwordUser: '', role: 'none' }}>
                                                {({ state, setState }) => (
                                                    <React.Fragment>
                                                        <SideSheet
                                                            isShown={state.isShown}
                                                            position={Position.LEFT}
                                                            onCloseComplete={() => setState({ isShown: false })}
                                                        >
                                                            <div className="side-sheet-content">
                                                                <div className="side-sheet-title">إدارة موظفي الصيانة</div>
                                                                
                                                                <div>
                                                                    <label className="form-label">اسم الموظف</label>
                                                                    <input 
                                                                        autoComplete='off' 
                                                                        type='text' 
                                                                        placeholder='اسم الموظف' 
                                                                        className='modern-input'
                                                                        onChange={(e) => setState({ nameUser: e.target.value })} 
                                                                    />
                                                                </div>
                                                                
                                                                <div>
                                                                    <label className="form-label">رقم الهاتف</label>
                                                                    <input 
                                                                        autoComplete='off' 
                                                                        type='number' 
                                                                        placeholder='رقم الهاتف' 
                                                                        className='modern-input'
                                                                        onChange={(e) => setState({ phoneUser: e.target.value })} 
                                                                    />
                                                                </div>
                                                                
                                                                <div>
                                                                    <label className="form-label">كلمة المرور</label>
                                                                    <input 
                                                                        autoComplete='off' 
                                                                        type='text' 
                                                                        placeholder='كلمة المرور' 
                                                                        className='modern-input'
                                                                        onChange={(e) => setState({ passwordUser: e.target.value })} 
                                                                    />
                                                                </div>
                                                                
                                                                <div>
                                                                    <label className="form-label">الوظيفة</label>
                                                                    <select 
                                                                        className="modern-select"
                                                                        onChange={(e) => setState({ role: e.target.value })}
                                                                    >
                                                                        <option value="none">اختر الوظيفة</option>
                                                                        <option value="-5">صيانة</option>
                                                                        <option value="-6">سوفت</option>
                                                                        <option value="-7">فحص</option>
                                                                        <option value="3">تجهيز</option>
                                                                    </select>
                                                                </div>
                                                                
                                                                <button 
                                                                    className="modern-btn"
                                                                    style={{ width: '100%', marginTop: '20px' }}
                                                                    onClick={() => {
                                                                        if (state.role == "none") {
                                                                            window.alert('اختر الوظيفة')
                                                                            return -1;
                                                                        }

                                                                        axios.post(host + `dashbord/admin`,
                                                                            qs.stringify({ name: state.nameUser, password: state.passwordUser, email: state.phoneUser, role: state.role }), {
                                                                            headers: {
                                                                                "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token")
                                                                            }
                                                                        })
                                                                            .then(response => {
                                                                                toast('تمت الإضافة بنجاح', {
                                                                                    position: "bottom-center",
                                                                                    autoClose: 5000,
                                                                                    hideProgressBar: false,
                                                                                    closeOnClick: true,
                                                                                    pauseOnHover: true,
                                                                                    draggable: true
                                                                                });
                                                                            })
                                                                            .catch(error => {
                                                                                window.alert(error.response.data.message)
                                                                                console.log(error.response.data.message)
                                                                                this.setState({ spinerBtn: false })
                                                                            })

                                                                        setState({ isShown: false })
                                                                    }}
                                                                >
                                                                    إضافة الموظف
                                                                </button>

                                                                <div className="side-sheet-title" style={{ marginTop: '40px' }}>
                                                                    قائمة الموظفين
                                                                </div>
                                                                
                                                                <Table className="modern-table" dir="rtl" striped bordered hover>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>#</th>
                                                                            <th>اسم الموظف</th>
                                                                            <th>رقم الهاتف</th>
                                                                            <th>الوظيفة</th>
                                                                            <th>تعديل كلمة المرور</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {this.state.admins.map((admin, i) =>
                                                                            <tr key={i}>
                                                                                <td>{admin.id}</td>
                                                                                <td>{admin.name}</td>
                                                                                <td>{admin.email}</td>
                                                                                <td>{admin.role}</td>
                                                                                <td>
                                                                                    <Component initialState={{ isShown: false, nameUser: '', phoneUser: '', passwordUser: '', }}>
                                                                                        {({ state: innerState, setState: setInnerState }) => (
                                                                                            <React.Fragment>
                                                                                                <Dialog
                                                                                                    isShown={innerState.isShown}
                                                                                                    confirmLabel='تعديل'
                                                                                                    cancelLabel='إلغاء'
                                                                                                    onConfirm={() => {
                                                                                                        axios.post(host + `dashbord/admins/password`,
                                                                                                            qs.stringify({ password: innerState.passwordUser, id: admin.id, }), {
                                                                                                            headers: {
                                                                                                                "Content-Type": "application/x-www-form-urlencoded", token: cookies.get("token")
                                                                                                            }
                                                                                                        })
                                                                                                            .then(response => {
                                                                                                                toast('تم التغيير بنجاح', {
                                                                                                                    position: "bottom-center",
                                                                                                                    autoClose: 5000,
                                                                                                                    hideProgressBar: false,
                                                                                                                    closeOnClick: true,
                                                                                                                    pauseOnHover: true,
                                                                                                                    draggable: true
                                                                                                                });
                                                                                                            })
                                                                                                            .catch(error => {
                                                                                                                console.log(error.response.data.message)
                                                                                                                this.setState({ spinerBtn: false })
                                                                                                            })
                                                                                                    }}
                                                                                                    position={Position.LEFT}
                                                                                                    onCloseComplete={() => setInnerState({ isShown: false })}
                                                                                                >
                                                                                                    <div style={{ padding: '20px' }}>
                                                                                                        <h3>تعديل كلمة المرور</h3>
                                                                                                        <input 
                                                                                                            autoComplete='off' 
                                                                                                            type='text' 
                                                                                                            placeholder='كلمة المرور الجديدة' 
                                                                                                            className='modern-input'
                                                                                                            onChange={(e) => setInnerState({ passwordUser: e.target.value })} 
                                                                                                        />
                                                                                                    </div>
                                                                                                </Dialog>
                                                                                                <Key 
                                                                                                    style={{ cursor: "pointer", color: '#667eea', fontSize: '1.5rem' }} 
                                                                                                    onClick={() => setInnerState({ isShown: true })} 
                                                                                                />
                                                                                            </React.Fragment>
                                                                                        )}
                                                                                    </Component>
                                                                                </td>
                                                                            </tr>
                                                                        )}
                                                                    </tbody>
                                                                </Table>
                                                            </div>
                                                        </SideSheet>
                                                        
                                                        <div className="action-card" onClick={() => setState({ isShown: true })}>
                                                            <div style={{ textAlign: 'center' }}>
                                                                <div className="card-icon">🔧</div>
                                                                <div className="card-title">الصيانة والتجهيز</div>
                                                                <div className="card-description">إدارة موظفي الصيانة والتجهيز</div>
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )}
                                            </Component>

                                            {/* Order Management Button */}
                                            <a href="/MenegeEmployee" className="action-card">
                                                <div style={{ textAlign: 'center' }}>
                                                    <div className="card-icon">📦</div>
                                                    <div className="card-title">إدارة موظفي الطلبات</div>
                                                    <div className="card-description">إدارة الموظفين المسؤولين عن معالجة الطلبات</div>
                                                </div>
                                            </a>

                                            {/* Employee Reports Button */}
                                            <a href="/Employee" className="action-card">
                                                <div style={{ textAlign: 'center' }}>
                                                    <div className="card-icon">📊</div>
                                                    <div className="card-title">تقارير موظفي الطلبات</div>
                                                    <div className="card-description">عرض تقارير أداء موظفي الطلبات والإحصائيات</div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </Container>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                    }}
                </Context.Consumer>
            )
        }
        else {
            return (
                <Login />
            )
        }
    }
}

export default Category;